import React from "react"
import { Link, useI18next } from "@zestia/gatsby-plugin-react-i18next"
import languages from "../../../languages"

const LinkToOtherLanguage = ({
  language,
  isCurrentLanguage,
  originalPath,
  availableSlugs,
  setShowMenu,
}) => {
  // TODO: Better name than `availableSlugs`? Need to make it clear that these are slugs that vary per language instead of just doing `/es/${originalPath}`
  const slug = availableSlugs.find(
    availableSlug => availableSlug.lang === language.key,
  )?.slug

  if (isCurrentLanguage)
    return (
      <span
        className="language-switcher__menu-item language-switcher__menu-item-selected"
        onClick={setShowMenu}
      >
        {language.displayName}
      </span>
    )

  return (
    <Link
      className="language-switcher__menu-item"
      to={slug ?? originalPath}
      language={language.key}
    >
      {language.displayName}
    </Link>
  )
}

const LanguageSwitcher = ({
  availableSlugs,
  showMenu,
  setShowMenu,
  light = false,
}) => {
  const { originalPath, language } = useI18next()

  return (
    <div className="menu menu--relative">
      <button
        className="nav-bar__btn language-switcher"
        onClick={setShowMenu}
        aria-label="Language switcher"
      >
        <GeoLocationIcon light={light} />{" "}
        <span className="language-switcher__label">
          {languages.find(lang => lang.key === language).displayName}
        </span>
        <ArrowIcon light={light} />
      </button>
      {showMenu && (
        <div
          className={`menu__mega-menu language-switcher__menu ${
            showMenu ? "menu__mega-menu--open" : ""
          }`}
        >
          <ul>
            {languages
              .filter(({ key }) => {
                const pageExistsInAllLanguages = availableSlugs.length === 0
                const pageExistsInLanguage = availableSlugs.some(
                  ({ lang }) => lang === key,
                )
                return pageExistsInAllLanguages || pageExistsInLanguage
              })
              .map(lang => (
                <LinkToOtherLanguage
                  key={lang.key}
                  language={lang}
                  isCurrentLanguage={lang.key === language}
                  originalPath={originalPath}
                  availableSlugs={availableSlugs}
                  showMenu={showMenu}
                  setShowMenu={() => handleToggle("language")}
                />
              ))}
          </ul>
        </div>
      )}
    </div>
  )
}

const GeoLocationIcon = ({ light }) => {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11 21C13.2167 20.9999 15.3705 20.2636 17.1234 18.9067C18.8762 17.5498 20.1288 15.6492 20.6844 13.5033M11 21C8.78334 20.9999 6.62949 20.2636 4.87664 18.9067C3.12379 17.5498 1.8712 15.6492 1.31556 13.5033M11 21C13.7611 21 16 16.5222 16 11C16 5.47778 13.7611 1 11 1M11 21C8.23889 21 6 16.5222 6 11C6 5.47778 8.23889 1 11 1M20.6844 13.5033C20.89 12.7033 21 11.8644 21 11C21.0027 9.28012 20.5598 7.58888 19.7144 6.09111M20.6844 13.5033C17.7213 15.146 14.388 16.0053 11 16C7.48667 16 4.18556 15.0944 1.31556 13.5033M1.31556 13.5033C1.10528 12.6855 0.999253 11.8444 1 11C1 9.21667 1.46667 7.54111 2.28556 6.09111M11 1C12.7736 0.999261 14.5155 1.4704 16.0469 2.36507C17.5783 3.25975 18.8441 4.54574 19.7144 6.09111M11 1C9.2264 0.999261 7.48453 1.4704 5.95312 2.36507C4.42171 3.25975 3.1559 4.54574 2.28556 6.09111M19.7144 6.09111C17.2952 8.18659 14.2006 9.33794 11 9.33333C7.66889 9.33333 4.62222 8.11111 2.28556 6.09111"
        stroke={light ? "#fff" : "#111"}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

const ArrowIcon = ({ light }) => {
  return (
    <svg
      fill="none"
      height="10"
      viewBox="0 0 9 10"
      width="9"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="m7.50049 3.5-3 3-3-3"
        stroke={light ? "#fff" : "#1f2e5c"}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.125"
      />
    </svg>
  )
}

export default LanguageSwitcher
